import { ProjectTypes } from '../enums';

const isClassicProject = (project) => project?.type === ProjectTypes.CLASSIC;

const isSwiftProject = (project) => project?.type === ProjectTypes.SWIFT;

const isProProject = (project) => project?.type === ProjectTypes.PRO;

const isOccasionBookProject = (project) => project?.type === ProjectTypes.OCCASION_BOOK;

export default {
  isClassicProject,
  isSwiftProject,
  isProProject,
  isOccasionBookProject,
};
